import ENTITY_DATA from "../../../../data/index.js";
import makeFormRequest from "../../../../helpers/form-request.js";
import ServerResponse from "../../../../helpers/render-server-response.js";
import Request from "../../../../helpers/request.js";
import APP_COMPONENTS from "../components/index.js";
export default {
    execute: async (data) => {
        const { form, submitBtn } = data;
        const payload = {
            title: form.servicetitle.value.trim(),
            desc: form.description.value.trim(),
            price: Number(form.price.value.trim()),
            orderIndex: ENTITY_DATA.getAll().length
        };
        const formRequest = makeFormRequest({ form, submitBtn });
        const response = await Request.post('/services/create', payload);
        formRequest.afterResponse(false);
        if (response.success) {
            ServerResponse.show({
                resp: response,
                respTitle: 'SUCCESS',
                respText: `Service added successfully.`
            });
            APP_COMPONENTS.serviceForms.update(data.id, response.id);
            ENTITY_DATA.add({ id: response.id, title: response.title });
            return;
        }
        ServerResponse.show({
            resp: response,
            respTitle: 'ERROR',
            respText: response.error
        });
    }
};
